import { render, staticRenderFns } from "./ExampleModal.vue?vue&type=template&id=de881770"
import script from "./ExampleModal.vue?vue&type=script&lang=js"
export * from "./ExampleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports